import { Directive, HostListener, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';

@Directive({
  selector: '[grTooltip]',
  hostDirectives: [
    {
      directive: Tooltip,
      inputs: [
        'pTooltip: grTooltip',
        'tooltipPosition: grTooltipPosition',
        'tooltipDisabled: grTooltipDisabled',
      ],
    },
  ],
})
export class GrTooltipDirective {
  private readonly tooltip = inject(Tooltip);

  @HostListener('pointerdown')
  @HostListener('pointercancel')
  protected dismiss(): void {
    this.tooltip.deactivate();
  }
}
